import axiosInstance from '../axiosInterceptor/axiosInstance'

// The federation games of the season teams a club team is paired into, between startAfter and
// endBefore, for the club team's calendar: [{ fedOrgId, competitionId, game }]. Games linked to one
// of the team's club games are left out (the club's copy is the one shown). Empty for anyone who
// may not browse the paired competitions, including a member refused the club's teams: the
// calendar just has nothing to add, so no error toast.
const getPairedCalendarGames = async (orgId, clubTeamId, startAfter, endBefore) => {
  try {
    const response = await axiosInstance.get(`v1/orgs/${orgId}/pairings/calendar-games`, {
      params: { clubTeamId, startAfter, endBefore },
      skipErrorNotification: true,
    })
    return response?.data ?? []
  } catch (error) {
    if ([401, 403].includes(error?.response?.status)) return []
    throw error
  }
}

export default getPairedCalendarGames
